import { clamp } from 'lodash'
import moment from 'moment'
import { humanReadableDateFormat } from './dates'

moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: '1 minute',
    mm: '%d minutes',
    h: '1 hour',
    hh: '%d hours',
    d: '1 day',
    dd: '%d days',
    w: '1 week',
    ww: '%d weeks',
    M: '1 month',
    MM: '%d months',
    y: '1 year',
    yy: '%d years',
  },
})

moment.relativeTimeThreshold('m', 45)
moment.relativeTimeThreshold('h', 20)
moment.relativeTimeThreshold('d', 14) // 13 days, 14 days => 2 weeks
moment.relativeTimeThreshold('w', 4) // 4 weeks, 5 weeks => 1 month

export const getDeadlineDate = (action) => {
  if (action.deadlineDate == null) return null
  const date = action.deadlineDate
  // check if 0 date (1970)
  if (date.valueOf() === 0) return null
  return moment(date)
}

export const getDurationString = (deadline) => {
  // assume start of day
  const now = moment().startOf('day')

  if (deadline.isSame(now, 'day')) {
    return 'Today'
  }

  if (deadline.isSame(now.clone().add(7, 'days'), 'day')) {
    return 'in 1 week'
  }

  const duration = deadline.from(now, false)
  return duration
}

const isToday = (date) => {
  const now = moment()
  return date.isSame(now, 'day')
}

export const getActionDeadlineText = (action, showDate = true) => {
  const deadline = getDeadlineDate(action)
  if (!deadline) return null

  if (isToday(deadline)) {
    return 'Due today'
  }

  const duration = getDurationString(deadline)

  if (showDate) {
    return `Due ${duration}, ${humanReadableDateFormat(deadline)}`
  } else {
    return `Due ${duration}`
  }
}

export const calculateProgress = (date) => {
  if (date == null) return null

  const today = moment().startOf('day')
  const diff = date.diff(today, 'days') + 1

  // 12 days seems to be max range on iOS
  const progress = clamp(1 - diff / 12, 0, 1)

  return progress
}
